var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
import { COUNTRY_CODE, CURRENCY_ID } from '../constants';
import { getNotchesByCountryAndLanguage } from './notchConfig';
var SERVER_NUMBER_CONVERT_RATIO = 100000;
var COUNTRY_CONF = (_a = {},
    _a[COUNTRY_CODE.SG] = {
        currencies: (_b = {},
            _b[CURRENCY_ID.SGD] = {},
            _b),
        defaultCurrency: CURRENCY_ID.SGD,
    },
    _a[COUNTRY_CODE.ID] = {
        currencies: (_c = {},
            _c[CURRENCY_ID.IDR] = {},
            _c),
        defaultCurrency: CURRENCY_ID.IDR,
    },
    _a[COUNTRY_CODE.MY] = {
        currencies: (_d = {},
            _d[CURRENCY_ID.MYR] = {},
            _d),
        defaultCurrency: CURRENCY_ID.MYR,
    },
    _a[COUNTRY_CODE.PH] = {
        currencies: (_e = {},
            _e[CURRENCY_ID.PHP] = {},
            _e),
        defaultCurrency: CURRENCY_ID.PHP,
    },
    _a[COUNTRY_CODE.TW] = {
        currencies: (_f = {},
            _f[CURRENCY_ID.TWD] = {},
            _f),
        defaultCurrency: CURRENCY_ID.TWD,
    },
    _a[COUNTRY_CODE.TH] = {
        currencies: (_g = {},
            _g[CURRENCY_ID.THB] = {},
            _g),
        defaultCurrency: CURRENCY_ID.THB,
    },
    _a[COUNTRY_CODE.VN] = {
        currencies: (_h = {},
            _h[CURRENCY_ID.VND] = {},
            _h),
        defaultCurrency: CURRENCY_ID.VND,
    },
    _a[COUNTRY_CODE.IR] = {
        currencies: (_j = {},
            _j[CURRENCY_ID.IRR] = {
                convertRate: 10 * SERVER_NUMBER_CONVERT_RATIO,
            },
            _j[CURRENCY_ID.MMK] = {},
            _j),
        defaultCurrency: CURRENCY_ID.IRR,
        serverCurrency: CURRENCY_ID.MMK,
    },
    _a[COUNTRY_CODE.MM] = {
        currencies: (_k = {},
            _k[CURRENCY_ID.MMK] = {},
            _k),
        defaultCurrency: CURRENCY_ID.MMK,
    },
    _a[COUNTRY_CODE.HK] = {
        currencies: (_l = {},
            _l[CURRENCY_ID.HKD] = {},
            _l),
        defaultCurrency: CURRENCY_ID.HKD,
    },
    _a[COUNTRY_CODE.BR] = {
        currencies: (_m = {},
            _m[CURRENCY_ID.BRL] = {},
            _m),
        defaultCurrency: CURRENCY_ID.BRL,
    },
    _a[COUNTRY_CODE.CN] = {
        currencies: (_o = {},
            _o[CURRENCY_ID.CNY] = {},
            _o),
        defaultCurrency: CURRENCY_ID.CNY,
    },
    _a[COUNTRY_CODE.MX] = {
        currencies: (_p = {},
            _p[CURRENCY_ID.MXN] = {},
            _p),
        defaultCurrency: CURRENCY_ID.MXN,
    },
    _a[COUNTRY_CODE.CO] = {
        currencies: (_q = {},
            _q[CURRENCY_ID.COP] = {},
            _q),
        defaultCurrency: CURRENCY_ID.COP,
    },
    _a[COUNTRY_CODE.CL] = {
        currencies: (_r = {},
            _r[CURRENCY_ID.CLP] = {},
            _r),
        defaultCurrency: CURRENCY_ID.CLP,
    },
    _a[COUNTRY_CODE.AR] = {
        currencies: (_s = {},
            _s[CURRENCY_ID.ARS] = {},
            _s),
        defaultCurrency: CURRENCY_ID.ARS,
    },
    _a[COUNTRY_CODE.PL] = {
        currencies: (_t = {},
            _t[CURRENCY_ID.PLN] = {},
            _t),
        defaultCurrency: CURRENCY_ID.PLN,
    },
    _a[COUNTRY_CODE.ES] = {
        currencies: (_u = {},
            _u[CURRENCY_ID.EUR] = {},
            _u),
        defaultCurrency: CURRENCY_ID.EUR,
    },
    _a[COUNTRY_CODE.FR] = {
        currencies: (_v = {},
            _v[CURRENCY_ID.EUR] = {
                separator: ' ',
            },
            _v),
        defaultCurrency: CURRENCY_ID.EUR,
    },
    _a[COUNTRY_CODE.IN] = {
        currencies: (_w = {},
            _w[CURRENCY_ID.INR] = {},
            _w),
        defaultCurrency: CURRENCY_ID.INR,
    },
    _a[COUNTRY_CODE.US] = {
        currencies: (_x = {},
            _x[CURRENCY_ID.USD] = {},
            _x),
        defaultCurrency: CURRENCY_ID.USD,
    },
    _a[COUNTRY_CODE.KR] = {
        currencies: (_y = {},
            _y[CURRENCY_ID.KRW] = {},
            _y),
        defaultCurrency: CURRENCY_ID.KRW,
    },
    _a);
export function getCountryConfig(country, language) {
    var countryCode = typeof country === 'string'
        ? country.toUpperCase()
        : country;
    var notches = getNotchesByCountryAndLanguage(countryCode, language);
    return __assign(__assign({}, COUNTRY_CONF[countryCode]), { notches: notches });
}
